import {
  UserGroupGlobeIcon,
  UserMessageIcon,
  UserTrendUpIcon,
} from '@execonline-inc/execonline-ui';
import { assertNever } from '@kofno/piper';
import { T } from '../../../../../Translations';
import { ProgramCategory, programCategoryLabel } from '../../../../Licensing/ProgramCategories';

// The same icons and colors the Builder v2 course tiles use for offering type,
// so a course reads the same on both screens.
export function CategoryIcon({ category }: { category: ProgramCategory }) {
  switch (category) {
    case 'professor-led':
      return <UserGroupGlobeIcon color="purple" size="xs" />;
    case 'on-demand':
      return <UserTrendUpIcon color="teal" size="xs" />;
    case 'leadership-coaching':
    case 'group-coaching':
      return <UserMessageIcon color="purple" size="xs" />;
    default:
      return assertNever(category);
  }
}

function CategoryBadge({ category }: { category: ProgramCategory }) {
  return (
    <span
      className="inline-flex flex-none items-center gap-1.5 rounded-full border border-border bg-muted px-2.5 py-1 text-foreground"
      style={{ fontSize: 'var(--text-xs)', fontWeight: 'var(--font-weight-semibold)' }}
    >
      <CategoryIcon category={category} />
      <T kind={programCategoryLabel(category)} />
    </span>
  );
}

export default CategoryBadge;
